import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11 32C11.1671 27.5556 15.1271 24 20 24C24.3457 24 27.9843 26.8444 28.82 30.6252C28.9228 31.0637 28.9743 31.5259 29 31.9881",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 21.0065C23.3137 21.0065 26 18.3188 26 15.0033C26 11.6877 23.3137 9 20 9C16.6863 9 14 11.6877 14 15.0033C14 18.3188 16.6863 21.0065 20 21.0065Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})]
});
const ForwardRef = forwardRef(SvgPerson);
export default ForwardRef;
